

/* ============
* Login Index Page
* ============
*
* Page where the user can login.
*/
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'

import {getBriefJobs,getFindJobs} from '@/api/service/index';

export default {

data() {
return {
code:'',
name:'',
type:'',
education:'',
jobList:[],
lists:[],//下拉刷新时获取的更新数据
pageNo: 1,//当前页数
briefPageNo:1,
sign:0,
pullupEnabled: true,
status: {
pullupStatus: 'default',
pulldownStatus: 'default'
},
};
},
components: {
Group,Cell,Scroller,Spinner
},
/**
* The methods the page can use.
*/
methods: {
/**
* Will log the user in.
*
* @param {Object} user The user to be logged in.
*/
getBriefJobs () {
this.pageNo = 1;
let param = {
pageNo:this.pageNo,
code:this.code,
name:this.name,
education:this.education
}
getBriefJobs(param).then((res) => {
if(res.code == 0){
this.jobList = res.data.content;
if(this.jobList.length > 0){
this.$nextTick(() => {
this.$refs.scroller.reset();
})
}
}
})
},
getList () {
let param = {
pageNo:this.pageNo,
code:this.code
}
getBriefJobs(param).then((res) => {
if(res.code == 0){
this.jobList = res.data.content;
if(this.jobList.length > 0){
this.$nextTick(() => {
this.$refs.scroller.reset();
})
}
}
})
},


getFindJobs(){
this.pageNo = 1;
let params = null;
if(this.education == ''){
params = {
pageNo:this.pageNo,
code:this.code,
name:this.name,
}
}else{
params = {
pageNo:this.pageNo,
code:this.code,
name:this.name,
education:this.education
}
}
getFindJobs(params).then((res) => {
this.jobList.length = 0;
if(res.code == 0){
if(res.data.statusCode != -7){

this.jobList = res.data;
}
}
})
},
loadMore () {
if(this.sign == 0){
let param = null;
this.pageNo++;
if(this.education == ''){
param = {
pageNo:this.pageNo,
code:this.code,
name:this.name,
}
}else{
param = {
pageNo:this.pageNo,
code:this.code,
name:this.name,
education:this.education
}
}
getFindJobs(param).then((res) => {
if(res.code == 0){
this.lists = res.data;
if(this.lists.length > 0){
for(let i = 0; i < this.lists.length; i++){
this.jobList.push(this.lists[i])
}
this.$refs.scroller.donePullup();
this.$nextTick(() => {
this.$refs.scroller.reset();
})
}else{
this.$nextTick(() => {
this.$refs.scroller.disablePullup();
})
}
}else{
this.$nextTick(() => {
this.$refs.scroller.disablePullup();
})
}

})
}else{
this.briefPageNo++;
let param = {
pageNo:this.briefPageNo,
code:this.code
}
getBriefJobs(param).then((res) => {
if(res.code == 0){
this.lists = res.data.content;
if(this.lists.length > 0){
for(let i = 0; i < this.lists.length; i++){
this.jobList.push(this.lists[i])
}
this.$refs.scroller.donePullup();
this.$nextTick(() => {
this.$refs.scroller.reset();
})

}else{
this.$nextTick(() => {
this.$refs.scroller.disablePullup();
})
}
}else{
this.$nextTick(() => {
this.$refs.scroller.disablePullup();
})
}
})
}

},

refresh () {
if(this.sign == 0){
let param = null;
if(this.education == ''){
param = {
pageNo:1,
code:this.code,
name:this.name,
}
}else{
param = {
pageNo:1,
code:this.code,
name:this.name,
education:this.education
}
}
getFindJobs(param).then((res) => {
this.jobList.length = 0;
if(res.code == 0){
this.jobList = res.data;
if(this.jobList.length > 0){
this.$nextTick(() => {
this.$refs.scroller.donePulldown()
this.pullupEnabled && this.$refs.scroller.enablePullup()
})
}
}
})
}else{
let param = {
pageNo:1,
code:this.code
}
getBriefJobs(param).then((res) => {
this.jobList.length = 0;
if(res.code == 0){
this.jobList = res.data.content;
if(this.jobList.length > 0){
this.$nextTick(() => {
this.$refs.scroller.donePulldown()
this.pullupEnabled && this.$refs.scroller.enablePullup()
})
}
}
})
}

},
toDetail(item){
this.$router.push({path: '/gw/detail',query:{name:item.name,company:item.company,count:item.count,recruitAddress:item.recruitAddress,education:item.education,age:item.age,request:item.request,salary:item.salary,rest:item.rest,boardLodging:item.boardLodging,contact:item.contact,phone:item.phone,unitAddress:item.unitAddress,traffic:item.traffic,createDate:item.createDate,endDate:item.endDate}})
}
},
mounted () {
if (typeof(this.$route.query.code) == "undefined" || this.$route.query.code == ""){

}else{
this.code = this.$route.query.code;
this.sign = this.$route.query.sign;
if(this.sign == 0){
if(this.$route.query.education != '不限'){
this.education = this.$route.query.education;
}
this.name = this.$route.query.name;
this.getFindJobs();
}else{
this.getList();
}

}
},
/**
* The components the page can use.
*/

};



// WEBPACK FOOTER //
// ./src/pages/gw/list.vue